import { css } from '@emotion/react';

export const wrapper = css`
    position: relative;
`;

export const floatingChatroomAccess = css`
    position: fixed;
    width: auto;
    min-width: 70px;
    bottom: 0;
    right: 42px;
    background-color: #ffffff;
    height: 40px;
    box-sizing: content-box;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    border-bottom: 2px solid #009faa;
    border-right: none;
    box-shadow: rgba(141, 150, 170, 0.4) 0px 1px 4px;
    padding: 0;
    align-items: center;
    justify-content: center;
    border-right: 1px dashed #f0f3f7;
    cursor: pointer;
    flex-wrap: nowrap;
    z-index: 1000;
`;

export const hangOnRight = css`
    @media only screen and (min-device-width: 0px) and (max-device-width: 699px) {
        bottom: 120px;
        right: 0;
        border-bottom: none;
        border-right: 2px solid #009faa;
        border-radius: 8px 0 0 8px;
    }
`;

export const chatBox = css`
    display: flex;
    padding: 12px;
`;

export const careBox = css`
    display: flex;
    padding: 2px 12px;
    border-left: 1px solid #f0f3f7;

    svg {
        fill: #8d96aa;
    }

    &:hover {
        svg {
            fill: #009faa;
        }
    }
`;

export const chatText = css`
    margin: 0;
    padding-left: 5px;
    display: block;
    position: relative;
    font-weight: 700;
    font-family:
        'Open Sauce One',
        'Nunito Sans',
        -apple-system,
        sans-serif;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #8d96aa;
    text-decoration: initial;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const notifSpan = css`
    position: absolute;
    top: -4px;
    right: 102px;
`;

export const careNotifSpan = css`
    position: absolute;
    top: -9px;
    right: 4px;
`;
